import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import Login from './Login';
import Dashboard from './Dashboard';
import PasswordRecovery from './components/PasswordRecovery';
import PasswordReset from './components/PasswordReset';
import { useAuth } from './hooks/useAuth';
import './App.css';
import ChecklistModule from './modules/checklist';
import MonitoramentoModule from './modules/monitoramento/MonitoramentoModule';
import MovimentacoesPoligonos from './modules/monitoramento/MovimentacoesPoligonos';

interface User {
  id: number;
  username: string;
  nome: string;
  nm_acesso?: string;
  nm_setor?: string;
  modules: string[];
}

// Componente wrapper para o Login com navegação
const LoginWrapper: React.FC<{ onLoginSuccess: (userData: User, token: string) => void }> = ({ onLoginSuccess }) => {
  const navigate = useNavigate();
  
  const handleForgotPassword = () => {
    navigate('/recuperar-senha');
  };
  
  return <Login onLoginSuccess={onLoginSuccess} onForgotPassword={handleForgotPassword} />;
};

// Componente principal da aplicação
const AppContent: React.FC = () => {
  const { user, loading, login, logout, isAuthenticated } = useAuth();

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        fontSize: '18px' 
      }}>
        Verificando autenticação...
      </div>
    );
  }

  const handleLoginSuccess = (userData: User, token: string) => {
    login(userData, token);
  };

  const handleLogout = () => {
    logout();
  };

  return (
    <Routes>
      <Route 
        path="/login" 
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <div className="login-container">
              <LoginWrapper onLoginSuccess={handleLoginSuccess} />
            </div>
          )
        } 
      />
      
      <Route 
        path="/recuperar-senha" 
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <PasswordRecovery />
          )
        } 
      />
      
      <Route 
        path="/redefinir-senha" 
        element={
          isAuthenticated ? (
            <Navigate to="/dashboard" replace />
          ) : (
            <PasswordReset />
          )
        } 
      />
      
      <Route 
        path="/dashboard" 
        element={
          isAuthenticated && user ? (
            <div className="dashboard-container">
              <Dashboard user={user} onLogout={handleLogout} />
            </div>
          ) : (
            <Navigate to="/login" replace />
          )
        } 
      />
      <Route
        path="/checklist"
        element={
          isAuthenticated && user ? (
            <ChecklistModule />
          ) : (
            <Navigate to="/login" replace />
          )
        }
      />
      
      <Route 
        path="/" 
        element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} 
      />
    </Routes>
  );
};

function App() {
  return (
    <Router>
      <Routes>
        <Route
          path="/monitoramento/tv"
          element={<MonitoramentoModule publicTvMode />}
        />
        <Route
          path="/monitoramento/poligonos"
          element={<MovimentacoesPoligonos />}
        />
        <Route path="/*" element={<AppContent />} />
      </Routes>
    </Router>
  );
}

export default App;
